// Generate a unique id for new entities. Output is 15 chars over the
// `[a-z0-9]` alphabet to match PocketBase 0.22.x's record id validator
// (`models.DefaultIdLength`); UUIDs are 36 chars and PB 400s on insert.
//
// Rejection-sampling each random byte (drop bytes ≥ 252) avoids modulo
// bias and keeps the distribution uniform — ~77 bits of entropy is
// comfortably collision-safe for our scale.

const ID_ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';
const ID_LENGTH = 15;
const REJECT_THRESHOLD = Math.floor(256 / ID_ALPHABET.length) * ID_ALPHABET.length;

// Built from the same alphabet/length constants as `uid()` so a future
// bump to either side propagates without a separate regex to keep in
// sync. Matched here lazily because the values are module-static.
const ID_REGEX = new RegExp(`^[${ID_ALPHABET}]{${ID_LENGTH}}$`);

export function uid(): string {
  const out: string[] = [];
  const buf = new Uint8Array(1);
  while (out.length < ID_LENGTH) {
    globalThis.crypto.getRandomValues(buf);
    const byte = buf[0]!;
    if (byte >= REJECT_THRESHOLD) continue;
    out.push(ID_ALPHABET[byte % ID_ALPHABET.length]!);
  }
  return out.join('');
}

// Predicate for the PocketBase 0.22.x record-id shape. Used by the boot
// legacy-id reset (see #12) and the outbox drain to drop pre-existing
// UUID-shaped entries that PB will never accept.
export function isValidPbId(id: string): boolean {
  return ID_REGEX.test(id);
}
